<template>
    <ModalDialogContainer ref="modalContainer" v-model:display="displayStatus" @keydown="escapeToClose">
        <div class="modal-dialog modal-md" role="document" @click="stopPropagationEvent">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="modal-title">{{ $t("Send Transcription/Summary") }}</div>
                    <button type="button" class="btn-close" :title="$t('Close')" @click="close"></button>
                </div>
                <div class="modal-body">
                    <label>{{ $t("Would you like to receive a full transcription or an AI-generated summary of the conversation to your email?") }}</label>
                    <br><br>
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="transcription-input" v-model="transcription">
                        <label for="transcription-input">{{ $t("Full Transcription") }}</label>
                    </div>
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="summary" v-model="summary">
                        <label for="summary">{{ $t("AI-generated Summary") }}</label>
                    </div>
                    <div v-if="error" class="error-message">{{ error }}</div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" :disabled="!summary && !transcription" @click="send"><i class="fa-regular fa-paper-plane"/> {{ $t("Send") }}</button>
                    <button type="button" class="btn btn-cancel" @click="close">{{ $t("Cancel") }}</button>
                </div>
            </div>
        </div>
    </ModalDialogContainer>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useVModel } from "@/utils/v-model";

export default defineComponent({
    name: "SendRecordingModal",
    emits: ["update:display", "confirm"],
    props: {
        display: Boolean,
    },
    setup(props) {
        return {
            displayStatus: useVModel(props, "display"),
        };
    },
    data() {
        return {
            error: "", 

            transcription: false,
            summary: false,
        };
    },
    methods: {
        close: function () {
            this.displayStatus = false;
            this.reset();
        },

        send: function() {
            if (!this.transcription && !this.summary) {
                this.error = this.$t("Please select at least one option to proceed.");
                return;
            }
            this.$emit("confirm", this.transcription, this.summary);
            this.close();
        },

        escapeToClose: function (event) {
            if (event.key === "Escape") {
                this.displayStatus = false;
            }
        },

        stopPropagationEvent: function (e) {
            e.stopPropagation();
        },
        reset: function () {
            this.error = "";
        },
    },
    mounted: function () {
        if (this.display) {
            this.$autoFocus();
        }
    },
    watch: {
        display: function () {
            if (this.display) {
                this.$autoFocus();
            }
        },
    },
});
</script>

<style scoped>
/* @import "@/style/modals/delete-version.css"; */
</style>
